import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IServerErrorPayload {}

type InitialState = {
  lastApiAction?: any;
  lastIsRejectedApiError?: any;
  firstTimeInitialization: boolean;
};

const initialState: InitialState = {
  firstTimeInitialization: true,
};

const appConfigurationSlice = createSlice({
  name: "application-configuration",
  initialState: initialState,

  reducers: {
    updateLastApiAction: (state, action: PayloadAction<IServerErrorPayload>) => {
      state.lastApiAction = action.payload;
    },

    updatelastIsRejectedApiError: (state, action: PayloadAction<IServerErrorPayload>) => {
      state.lastIsRejectedApiError = action.payload;
    },

    updateFirstTimeInitialization: (state, action: PayloadAction<boolean>) => {
      state.firstTimeInitialization = action.payload;
    },
  },
});

export default appConfigurationSlice.reducer;
export const { updateLastApiAction, updatelastIsRejectedApiError, updateFirstTimeInitialization } =
  appConfigurationSlice.actions;
